import React from 'react';

import { LTCodeBlock, LTIconButton } from '@lambdatestincprivate/lt-components';

import DownloadIcon from '../../../../assets/download';

import ComponentNoDataFound from '../../../ComponentNoDataFound';

import styles from './index.module.css';

const Media = ({ downloadAsset, filesToRender = [] }) => {
  const totalFileCount = filesToRender && filesToRender.length;

  const renderFileInfo = (name = '', assetType = '') => {
    return (
      <>
        <div>{name}</div>
        <LTIconButton
          aria-label="Download"
          data-testid="metadata-media-download-btn"
          customStyle={{
            height: '16px',
            width: '16px',
          }}
          icon={DownloadIcon}
          onClick={() => {
            downloadAsset(assetType);
          }}
          variant={LTIconButton.IconButtonVariants.INVISIBLE}
          size={LTIconButton.Size.SMALL}
        />
      </>
    );
  };

  if (totalFileCount === 0) {
    return <ComponentNoDataFound message="Assets not found" />;
  }

  return (
      <LTCodeBlock
        removeBodyWrapper={true}
        title={`${totalFileCount} ${totalFileCount === 1 ? 'File' : 'Files'}`}
      >
        <div className={styles.container}>
          <div style={{ height: '1px' }} data-testid="metadata-media-file-list">
            {filesToRender.map(({ name, assetType }) => {
              return (
                <div className={styles.fileName}>
                  {renderFileInfo(name, assetType)}
                </div>
              );
            })}
          </div>
        </div>
      </LTCodeBlock>
  );
};

export default Media;
